import script from "./SimpleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleSelect.vue?vue&type=script&setup=true&lang=js"

import "./SimpleSelect.vue?vue&type=style&index=0&id=304b4b74&lang=css"

const __exports__ = script;

export default __exports__